<template>
  <div style="margin: 2px">
    <div class="bg_container">
      <!-- <img src="../assets/wellness_coupon_bg.png" alt /> -->
    </div>

    <div class="head_container">
      <div class="icon_text_container">
        <img class="icon" src="../assets/heals_logo.png" alt />
        <div>heals</div>
      </div>
      <div class="invite_detail_container">
        <div class="invite_title">
          Your friend <label>{{ ambassadorUser.fullName }}</label> has invited
          you to join Heals platform!
          <a href="/download/healsapp">Download now</a>
        </div>
        <div class="invite_qr_code_image">
          <div id="qrcode" ref="qrcode"/>
        </div>
        <!-- <div id="qrcode" ref="qrcode" style="background: red;width: 3rem;height: 3rem;"/> -->
      </div>
    </div>
    <!-- 如何联系大使 -->
    <div class="coupon_valid_table_container">
      <div class="coupon_detail_container">
        <div class="section_title">How to connect with friends</div>
        <div class="services_list_container">
          <div
            class="one_item"
            v-for="(item, i) in serviceItemsArray"
            v-bind:key="i"
          >
            <div
              v-for="(oneItem, i) in item.itemArray"
              v-bind:key="i"
              class="item_one_item_contianer"
            >
              <div class="how-connect-text_container">
                <div class="point"></div>
                <div class="text_container">
                  <div
                    class="text"
                    v-for="(sutTitle, i) in oneItem.subTitleItems"
                    v-bind:key="i"
                  >
                    {{ sutTitle }}
                  </div>
                  <div
                    v-if="oneItem.copyButton"
                    class="copy-button-container"
                    @click="openHealsapp"
                  >
                    OPEN
                  </div>
                </div>
              </div>
            </div>
            <div class="undline"></div>
          </div>
        </div>

        <!-- heals介绍 -->
        <div
          class="heals-solution-container"
          v-for="(item, i) in healsSolutionItems"
          v-bind:key="'item' + i"
        >
          <div class="section_title" style="margin-top: 0.5rem">
            {{ item.sectionTitle }}
          </div>
          <div
            class="sub_section_title"
            v-for="(subItem, i) in item.sectionItems"
            v-bind:key="'item' + i"
          >
            <div v-if="item.displayNumber" class="number">{{ i + 1 }}.</div>
            <div>{{ subItem }}</div>
          </div>
        </div>

        <!-- heals app download -->
        <div class="heals_healthcare_limited">
          Proudly brought to you by Heals Healthcare Limited
        </div>
        <div class="heals_app_download_info_container">
          <img
            class="heals_app_qr_code_image"
            src="../assets/heals_app_qr_code.png"
            alt
          />
          <div class="download_button_container">
            <a
              href="https://play.google.com/store/apps/details?id=com.healshealthcare.patientapp"
            >
              <img src="../assets/download_andrid.png" alt />
            </a>
            <a
              href="https://apps.apple.com/hk/app/heals-patient-app/id1442752092"
            >
              <img src="../assets/download_ios.png" alt />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  name: "wellness-coupon",
  comments: {
    QRCode,
  },
  data() {
    return {
      qrCodeUrl: window.location.href,
      inviteCode: "",
      ambassadorUser: {
        fullName: "",
      },
      serviceItemsArray: [
        {
          itemArray: [
            {
              subTitleItems: ["Use heals app to scan the QR code above"],
            },
          ],
        },
        {
          itemArray: [
            {
              copyButton: true,
              subTitleItems: [
                "Click the open button directly to open the heals app",
              ],
            },
          ],
        },
      ],

      healsSolutionItems: [
        {
          sectionTitle: "Heals is the solution",
          sectionItems: [
            "Introducing Heals, the digital medical companion that makes the lives of our users and their families easier. We combine the world of medical healthcare with the ease and advancement of modern technology. Our vision is to enhance patient experience through smart connections - join us and become a partner today!",
          ],
        },
        {
          sectionTitle: "The Heals application",
          sectionItems: [
            "We are reinventing the traditional ways of managing healthcare.",
            "The Heals application is the smart mobile organizer offering continuous and personalised medical care, all within the palm of your hand.",
          ],
        },
        {
          sectionTitle: "Key Features",
          displayNumber: true,
          sectionItems: [
            "We are the home for all your medical needs.",
            "We make your life easier.",
            "We help you find what you need.",
            "We keep track of your health.",
            "We remind you when you forget",
            "We eliminate the extra steps",
          ],
        },
        {
          sectionTitle: "Why Heals?",
          displayNumber: true,
          sectionItems: [
            "No matter if it is your own personal information.",
            "Or all your past and new medical and health records.",
            "We safeguard and protect all your data with the latest block chain technology.",
            "Putting your safety and privacy as our number one priority.",
          ],
        },
        {
          sectionTitle: "Start Now",
          sectionItems: [
            "We make your life easier.",
            "Get excited for the best smart healthcare assistant.",
            "Download now!",
          ],
        },
      ],
    };
  },

  mounted() {
    this.inviteCode = this.$route.params.inviteCode;
    this.getAmbassadorInviteUserInfo();
    this.createQrcode();
  },
  methods: {
    //获取大使信息
    getAmbassadorInviteUserInfo() {
      let that = this;
      this.$get(
        "/v1/user/Ambasador/info",
        { code: this._data.inviteCode },
        this,
        {}
      ).then((data) => {
        that.ambassadorUser = {
          fullName: data.ambassador.name,
          userId: data.ambassador.id,
        };
      });
    },
    //创建qr
    createQrcode() {
      var that = this;
      let qrcode = new QRCode("qrcode", {
        width: 124,
        height: 124,
        text: that.qrCodeUrl,
      });
    },

    openHealsapp() {
      // com.healshealthcare.patientapp

      let ua = navigator.userAgent.toLowerCase();
      //Android终端
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1; //iOS终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //iOS终端
        window.location = "com.healshealthcare.patientapp:" + this.qrCodeUrl;
      } else if (/(Android)/i.test(navigator.userAgent)) {
        //Android终端
        window.location = "com.healshealthcare.patientapp:" + this.qrCodeUrl;
      }
    },

    clickCopy() {},
    // 复制成功时的回调函数
    onCopy(e) {
      this.$toasted.show("OK", {
        theme: "bubble",
        position: "top-left",
        duration: 4000,
        fullWidth: true,
      });
    },
    // 复制失败时的回调函数
    onError(e) {
      this.$toasted.show("Failed", {
        theme: "bubble",
        position: "top-left",
        duration: 4000,
        fullWidth: true,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../style/ambassador-invite.css";
</style>



// WEBPACK FOOTER //
// src/components/ambassador-invite.vue